module.exports = __webpack_public_path__ + "img/aone_logo.d388cb97.svg";